import { LitElement, css, html } from '@lit'
import styles from '@nova/styles'
import { formatPrice } from '@nova/utils'

class NovaFreeShippingThreshold extends LitElement {
  static properties = {
    threshold: {
      type: Number,
    },
    cartSubtotal: {
      type: Number,
      state: true,
    },
    percentageValue: {
      type: Number,
      state: true,
    },
  }

  get percentageValue() {
    return (this.cartSubtotal / this.threshold) * 100
  }

  constructor() {
    super()
    document.addEventListener(
      'nova:changeQuantityFinished',
      this._handleUpdateProgressBar,
    )
    this.threshold = __NOVA_GLOBAL__.freeShippingThreshold
    this._asyncUpdateCart()
  }

  _asyncUpdateCart = async () => {
    try {
      const response = await fetch('/cart.js')
      if (!response.ok) {
        throw new Error('Error fetching cart')
      }
      const data = await response.json()
      this.cartSubtotal = data.items_subtotal_price / 100
    } catch {
      console.error('Error fetching cart')
    }
  }

  _handleUpdateProgressBar = () => {
    this._asyncUpdateCart()
  }

  _calculateRemaining() {
    return formatPrice((this.threshold - this.cartSubtotal) * 100)
  }

  _displayMessage() {
    let message
    if (this.cartSubtotal >= this.threshold) {
      message = 'Congratulations. You get free shipping!'
    } else {
      message = `${this._calculateRemaining()} more for free shipping.`
    }

    return message
  }

  render() {
    return html`
      <p>${this._displayMessage()}</p>
      <sl-progress-bar value=${this.percentageValue}></sl-progress-bar>
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: block;
        border-radius: 4px;
        background: var(--nova-brand-light);
        padding: 10px;
        margin-bottom: 20px !important;
      }

      p {
        font-size: 12px;
        margin: 0;
        margin-bottom: 3px;
      }

      sl-progress-bar {
        --height: 3px;
      }
    `,
  ]
}

customElements.define('nova-free-shipping-threshold', NovaFreeShippingThreshold)
